import { MatPaginatorIntl } from '@angular/material/paginator';

export function getCustomPaginatorIntl() {
  const paginatorIntl = new MatPaginatorIntl();

  paginatorIntl.itemsPerPageLabel = 'Items per page:';

  const originalRangeLabel = paginatorIntl.getRangeLabel;

  paginatorIntl.getRangeLabel = (page: number, pageSize: number, length: number) => {
    if (length === 0 || pageSize === 0) {
      return 'No items available';
    }
    
    if (pageSize >= length) {
      return `Showing all ${length} items`;
    }
    return originalRangeLabel(page, pageSize, length);
  };

  return paginatorIntl;
}
